// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__DCRds","list":"BalanceDue_list__2r0_D","listRow":"BalanceDue_listRow__1Ox4w","total":"BalanceDue_total__xA3EQ"};